import { createAsyncAction } from "../utils/actionCreators";

export const types = {
  OBTER_USUARIOS: "@@usuarioAdm/OBTER_USUARIOS",
  MOSTRAR_USUARIO: "@@usuarioAdm/MOSTRAR_USUARIO",
  EDITAR_USUARIO: "@@usuarioAdm/EDITAR_USUARIO",
  CRIAR_USUARIO: "@@usuarioAdm/CRIAR_USUARIO",
  DELETAR_USUARIO: "@@usuarioAdm/DELETAR_USUARIO",
};

export const actions = {
  obterUsuarios: createAsyncAction(types.OBTER_USUARIOS),
  mostrarUsuario: createAsyncAction(types.MOSTRAR_USUARIO),
  editarUsuario: createAsyncAction(types.EDITAR_USUARIO),
  criarUsuario: createAsyncAction(types.CRIAR_USUARIO),
  deletarUsuario: createAsyncAction(types.DELETAR_USUARIO),
};
